import { render, staticRenderFns } from "./ModalReembolso.vue?vue&type=template&id=80aee10a"
import script from "./ModalReembolso.vue?vue&type=script&lang=js"
export * from "./ModalReembolso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports